import React, { useContext, useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  IconButton,
  Button,
  Chip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Avatar,
  InputBase
} from '@mui/material';
import {
  Menu as MenuIcon,
  SentimentSatisfiedAlt as SentimentSatisfiedAltIcon,
  Settings as SettingsIcon,
  ContactSupport as ContactSupportIcon,
  ShieldMoon as ShieldMoon,
  Logout as LogoutIcon,
  Person as PersonIcon,
  MoreVert as MoreVertIcon,
  Search as SearchIcon,
  WorkspacePremium as WorkspacePremiumIcon,
  Check as CheckIcon,
  ChevronRight as ChevronRightIcon
} from '@mui/icons-material';
import CloseIcon from "@mui/icons-material/Close";


// 👇 Importa tu nuevo componente Drawer de perfil
import ProfileDrawer from "./ProfileDrawer";
import PlanComparisonModal from "./PlanComparisonModal";
import { DataContext } from "../context/DataContext";
import CreditsEngineService from "../services/CreditsEngineService";
import { HEADER_HEIGHT } from "./headerHeight";
import { useAppTheme } from "../themes/ThemeController";

const HeaderWithDropdown = ({
  drawerOpen,
  isMobile,
  handleDrawerToggle,
  userName,
  handleSignOut,
  onSettingsClick
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const open = Boolean(anchorEl);
  // Submenú "Tema": lista los temas de src/themes/ (themeRegistry).
  const { themeId, themes, setThemeId } = useAppTheme();
  const [themeAnchorEl, setThemeAnchorEl] = useState(null);

  // 👇 Estado para abrir/cerrar el Drawer de perfil
  const [profileOpen, setProfileOpen] = useState(false);

  // Entrada secundaria al modal de planes/facturación (ver también el
  // banner en OptimizedChatComponent.js).
  const { accountId, isPlatformRoot, isTenantAdmin } = useContext(DataContext);
  const [plansModalOpen, setPlansModalOpen] = useState(false);
  const [planInfo, setPlanInfo] = useState(null);

  useEffect(() => {
    if (!accountId) return;
    CreditsEngineService.getLimits({ accountId })
      .then((response) => setPlanInfo(response?.account_policy || null))
      .catch((err) => console.error('No se pudo obtener la información del plan actual', err));
  }, [accountId]);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setThemeAnchorEl(null);
  };

  const handleThemeSelect = (id) => {
    setThemeId(id);
    handleMenuClose();
  };


  /*
  configuration settings 
  */
  const handleSettingsClick = () => {
    handleMenuClose();
    // Llamar a la función para mostrar configuración
    if (onSettingsClick) {
      onSettingsClick();
    }
  };

  const handleContactClick = () => {
    handleMenuClose();
    // Lógica para contacto
    console.log('Abrir contacto');
  };

  // 👇 Aquí abrimos el Drawer en vez de solo log
  const handleProfileClick = () => {
    setProfileOpen(true);
    handleMenuClose();
  };

  const handlePlansClick = () => {
    setPlansModalOpen(true);
    handleMenuClose();
  };

  const handleLogoutFromMenu = () => {
    handleMenuClose();
    handleSignOut();
  };






  return (
    <>
    <AppBar
      position="fixed"
      color="inherit"
      elevation={0}
      sx={{
        width: '100%', // Siempre 100% del ancho
        left: 0, // Siempre desde el borde izquierdo
        right: 0, // Hasta el borde derecho
        ml: 0, // Sin margin left
        borderBottom: '1px solid var(--wb-x-border-3c3c52, #3c3c52ff)',
        backgroundColor: 'var(--wb-x-bg-454a55, #454a55)',
        transition: 'all 0.3s ease',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar sx={{
        display: 'flex',
        justifyContent: 'space-between',
        // Una sola fila de alto fijo: con flexWrap en teléfonos el encabezado
        // pasaba a dos filas (~110 px) y tapaba el título de las páginas,
        // que solo reservan HEADER_HEIGHT.
        flexWrap: 'nowrap',
        height: HEADER_HEIGHT,
        minHeight: HEADER_HEIGHT,
        overflow: 'hidden',
        gap: 1,
        backgroundColor: 'var(--wb-bg-header)',
        ml: 0, // Sin margin left en el Toolbar
        width: '100%', // Ocupa todo el ancho disponible
        pl: 2, // Espaciado fijo para alinear con el contenido principal
        transition: 'padding-left 0.3s ease',
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flex: 1 }}>



          {/* Solo mostrar el botón de hamburguesa en móvil o cuando el drawer está cerrado */}
          {/* Botón hamburguesa / cerrar */}
          {(isMobile || !drawerOpen || drawerOpen) && (
            <IconButton
              onClick={handleDrawerToggle}
              edge="start"
              sx={{
                mr: 1, color: 'var(--wb-x-text-ffffff, #ffffffff)',
                '&:hover': {
                  backgroundColor: 'var(--wb-x-bg-f0f0f017, #f0f0f017)'
                }
              }}
            >
              {drawerOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>
          )}

          <Box sx={{ ml: (!drawerOpen && !isMobile) ? 4 : 0 }}>
            <img
              src="/images/logo.png"
              alt="whisperbi"
              className="h-6 md:h-7 lg:h-8 w-auto object-contain"
            />

          </Box>
          <Box sx={{ display: 'flex', alignItems: 'baseline', minWidth: 0 }}>
            {/* En teléfonos el logo basta: el título no cabe en una fila. */}
            <Typography variant="h6" noWrap sx={{
              display: { xs: 'none', sm: 'block' },
              fontWeight: 600,
              fontSize: { sm: '1.1rem', md: '1.25rem' },
              color: 'var(--wb-text-strong)'
            }}>
              Data Analytics Assistant
            </Typography>
            <Typography variant="h6" sx={{
              fontWeight: 600,
              fontSize: isMobile ? '.50rem' : '.80rem',
              color: 'var(--wb-x-text-00c4cc, #00C4CC)',
              ml: 0.5
            }}>
              Beta
            </Typography>

            {/*barra de busqueda -- solo desde md: en pantallas angostas
                forzaba una segunda fila del encabezado */}
            <Box
              sx={{
                flexGrow: 1, // para que se expanda en el centro
                display: { xs: 'none', md: 'flex' },
                justifyContent: 'center', // centrado horizontal
                mx: 2, // separación a los lados
              }}
            >
              <Box
                component="form"
                onSubmit={(e) => {
                  e.preventDefault();
                  console.log('Buscar:', searchQuery); // reemplaza con tu lógica
                }}
                sx={{
                  backgroundColor: 'var(--wb-x-bg-1a1a1a, #1a1a1a)', // fondo oscuro/
                  borderRadius: 2,
                  px: 1,
                  py: 0.5,
                  display: 'flex',
                  alignItems: 'center',
                  width: { md: 240, lg: 300 },
                  border: '1px solid var(--wb-x-border-0095ff, #0095ffff)' // borde naranja
                }}
              >
                <SearchIcon sx={{ color: 'var(--wb-x-text-0095ff, #0095ffff)', mr: 1 }} /> {/* ícono de lupa */}
                <InputBase
                  placeholder="Buscar Chat..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  sx={{
                    color: 'var(--wb-text-strong)',
                    flex: 1,
                    fontSize: '0.9rem',
                  }}
                  inputProps={{ 'aria-label': 'buscar' }}
                />
              </Box>
            </Box>

          </Box>
        </Box>

        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          gap: isMobile ? 1 : 2,
          ml: isMobile ? 'auto' : 0
        }}>

          {/* Botón del menú desplegable */}
          <IconButton
            onClick={handleMenuClick}
            sx={{
              color: 'var(--wb-text-strong)',
              '&:hover': {
                backgroundColor: 'var(--wb-overlay-10)',
              },
            }}
          >
            <MoreVertIcon />
          </IconButton>

          {/* Menú desplegable */}
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            PaperProps={{
              sx: {
                backgroundColor: 'var(--wb-bg-header)',
                color: 'var(--wb-text-strong)',
                borderColor: 'var(--wb-text-strong)',
                minWidth: 200,
                boxShadow: '0 4px 20px var(--wb-x-shadow-0000004c, rgba(0,0,0,0.3))',
                '& .MuiMenuItem-root': {
                  '&:hover': {
                    backgroundColor: 'var(--wb-overlay-10)',
                  },
                },
              },
            }}
          >
            {/* Header del menú con usuario */}
            <Box sx={{
              px: 2,
              py: 1.5,
              borderBottom: '1px solid var(--wb-overlay-10)',
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}>
              <Avatar
                sx={{
                  width: 32,
                  height: 32,
                  backgroundColor: 'var(--wb-x-bg-cc5f00, #cc5f00ff)',
                  fontSize: '0.9rem'
                }}
              >
                {userName?.charAt(0)?.toUpperCase()}
              </Avatar>
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                  {userName}
                </Typography>
              </Box>
            </Box>

            {/* configuraciones*/}
            <MenuItem onClick={handleSettingsClick}>
              <ListItemIcon>
                <SettingsIcon sx={{ color: 'var(--wb-text-strong)' }} />
              </ListItemIcon>
              <ListItemText primary="Ajustes" />
            </MenuItem>

            <MenuItem onClick={handleContactClick}>
              <ListItemIcon>
                <ContactSupportIcon sx={{ color: 'var(--wb-text-strong)' }} />
              </ListItemIcon>
              <ListItemText primary="Contacto" />
            </MenuItem>
            <MenuItem
              onClick={(event) => setThemeAnchorEl(event.currentTarget)}
              aria-haspopup="menu"
              aria-expanded={Boolean(themeAnchorEl)}
            >
              <ListItemIcon>
                <ShieldMoon sx={{ color: 'var(--wb-text-strong)' }} />
              </ListItemIcon>
              <ListItemText primary="Tema" secondary={themes.find((t) => t.id === themeId)?.label}
                secondaryTypographyProps={{ sx: { color: 'var(--wb-text-soft)' } }} />
              <ChevronRightIcon fontSize="small" sx={{ color: 'var(--wb-text-soft)' }} />
            </MenuItem>

            <MenuItem onClick={handlePlansClick}>
              <ListItemIcon>
                <WorkspacePremiumIcon sx={{ color: 'var(--wb-text-strong)' }} />
              </ListItemIcon>
              <ListItemText primary="Planes y facturación" />
            </MenuItem>

            <Divider sx={{ backgroundColor: 'var(--wb-overlay-10)' }} />

                          {/* 👇 Aquí abrimos el Drawer de Perfil */}
              <MenuItem onClick={handleProfileClick}>
                <ListItemIcon>
                  <PersonIcon sx={{ color: 'var(--wb-text-strong)' }} />
                </ListItemIcon>
                <ListItemText primary="Mi Perfil" />
              </MenuItem>

            <MenuItem onClick={handleLogoutFromMenu}>
              <ListItemIcon>
                <LogoutIcon sx={{ color: 'var(--wb-text-strong)' }} />
              </ListItemIcon>
              <ListItemText primary="Cerrar sesion" />
            </MenuItem>
          </Menu>

          {/* Submenú de temas */}
          <Menu
            anchorEl={themeAnchorEl}
            open={Boolean(themeAnchorEl)}
            onClose={() => setThemeAnchorEl(null)}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              sx: {
                backgroundColor: 'var(--wb-bg-header)',
                color: 'var(--wb-text-strong)',
                minWidth: 180,
                '& .MuiMenuItem-root:hover': { backgroundColor: 'var(--wb-overlay-10)' },
              },
            }}
          >
            {themes.map((theme) => (
              <MenuItem key={theme.id} selected={theme.id === themeId} onClick={() => handleThemeSelect(theme.id)}>
                <ListItemIcon>
                  {theme.id === themeId && <CheckIcon fontSize="small" sx={{ color: 'var(--wb-accent)' }} />}
                </ListItemIcon>
                <ListItemText primary={theme.label} />
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
    <ProfileDrawer
        open={profileOpen}
        onClose={() => setProfileOpen(false)}
        user={{
          name: userName || "",
        }}
      />
      <PlanComparisonModal
        open={plansModalOpen}
        onClose={() => setPlansModalOpen(false)}
        accountId={accountId}
        isTenantAdmin={isTenantAdmin}
        isPlatformRoot={isPlatformRoot}
        currentPlanId={planInfo?.plan_id}
        hasActiveSubscription={Boolean(planInfo?.stripe_subscription_id)}
        onPlanChanged={() => {
          if (!accountId) return;
          CreditsEngineService.getLimits({ accountId })
            .then((response) => setPlanInfo(response?.account_policy || null))
            .catch((err) => console.error('No se pudo refrescar la información del plan', err));
        }}
      />
    </>
  );
};

export default HeaderWithDropdown;
